import React, { FC } from 'react';
import classNames from 'classnames';

export const HorizontalDivider: FC<{ className?: string }> = ({
    className,
}) => <hr className={classNames('horizontal-divider', className)} />;
